import axios from '_u/axios'

// 活动列表
export const actList = (body) => {
    return axios.post('api/act/info/list', body)
}

//新增活动
export const actAdd = (body) => {
    return axios.post('api/act/info/add', body)
}

//删除活动
export const actDelete = (id) => {
    return axios.post('api/act/info/delete', { id })
}

// 活动详情
export const actView= (id, viewType = 0) => {
    return axios.post('api/act/info/view', {id, viewType})
}

// 修改活动
export const actUpdate = (body) => {
    return axios.post('api/act/info/update', body)
}

// 发布/取消发布
export const publish = (id) => {
    return axios.post('api/act/info/publish', {id})
}

// 查询房源树
export const queryResources = (projId) => {
    return axios.post('api/act/info/queryResources', {projId})
}

